import { useEffect } from 'react';

/**
 * Al alinear la ilustración: vista cenital 2D. El pitch se restaura al salir.
 *
 * @param {{
 *   mapInstanceRef: { current: import('maplibre-gl').Map|null },
 *   enabled?: boolean,
 * }} options
 */
export function useCadAlignFlatView({ mapInstanceRef, enabled = false }) {
  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!map || !enabled) return undefined;

    let savedPitch = 0;
    try { savedPitch = map.getPitch(); } catch (_) { /* noop */ }
    try { map.touchPitch.disable(); } catch (_) { /* noop */ }
    try {
      map.easeTo({ pitch: 0, duration: 400 });
    } catch (_) { /* noop */ }

    return () => {
      try { map.touchPitch.enable(); } catch (_) { /* noop */ }
      if (!(savedPitch > 0)) return;
      try {
        map.easeTo({ pitch: savedPitch, duration: 400 });
      } catch (_) { /* noop */ }
    };
  }, [enabled, mapInstanceRef]);
}
